module.exports = "form:nth-child(1) mat-slide-toggle {\n  float: right;\n  margin-top: 20px; }\n\nform > mat-input-container {\n  display: block;\n  width: 100%; }\n\nform > mat-input-container textarea {\n    height: 410px;\n    resize: none; }\n\nform > mat-input-container textarea[formControlName=metaDescription] {\n      height: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/pages/page-form/page-form.component.scss
// module id = ./libs/atenea-cms-brand/src/pages/page-form/page-form.component.scss
// module chunks = main